import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const buttonIconFn = /* @__PURE__ */ createRecipe('button-icon', {
  "variant": "filled",
  "color": "neutral",
  "size": "m",
  "shape": "rounded"
}, [
  {
    "variant": "filled",
    "color": "primary",
    "css": {
      "color": "neutral.foreground.1.onBrand.enabled",
      "backgroundColor": "primary.background.2.enabled",
      "_hover": {
        "backgroundColor": "primary.background.2.hovered"
      },
      "_active": {
        "backgroundColor": "primary.background.2.actived"
      },
      "_expanded": {
        "backgroundColor": "primary.background.2.hovered"
      }
    }
  },
  {
    "variant": "filled",
    "color": "neutral",
    "css": {
      "color": "neutral.foreground.1.onBrand.enabled",
      "backgroundColor": "neutral.background.6.enabled",
      "_hover": {
        "backgroundColor": "neutral.background.6.hovered"
      },
      "_active": {
        "backgroundColor": "neutral.background.6.actived"
      },
      "_expanded": {
        "backgroundColor": "neutral.background.6.hovered"
      }
    }
  },
  {
    "variant": "filled",
    "color": "danger",
    "css": {
      "color": "neutral.foreground.1.onBrand.enabled",
      "backgroundColor": "danger.background.1.enabled",
      "_hover": {
        "backgroundColor": "danger.background.1.hovered"
      },
      "_active": {
        "backgroundColor": "danger.background.1.actived"
      },
      "_expanded": {
        "backgroundColor": "danger.background.1.hovered"
      }
    }
  },
  {
    "variant": "outlined",
    "color": "primary",
    "css": {
      "color": "primary.foreground.2.enabled",
      "borderColor": "primary.stroke.3.enabled",
      "_hover": {
        "color": "primary.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered",
        "borderColor": "primary.stroke.3.hovered"
      },
      "_active": {
        "color": "primary.foreground.2.actived",
        "backgroundColor": "neutral.background.2.actived",
        "borderColor": "primary.stroke.3.actived"
      },
      "_expanded": {
        "color": "primary.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered",
        "borderColor": "primary.stroke.3.hovered"
      }
    }
  },
  {
    "variant": "outlined",
    "color": "neutral",
    "css": {
      "color": "neutral.foreground.2.enabled",
      "borderColor": "neutral.stroke.7.enabled",
      "_hover": {
        "color": "neutral.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered",
        "borderColor": "neutral.stroke.7.hovered"
      },
      "_active": {
        "color": "neutral.foreground.2.actived",
        "backgroundColor": "neutral.background.2.actived",
        "borderColor": "neutral.stroke.7.actived"
      },
      "_expanded": {
        "color": "neutral.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered",
        "borderColor": "neutral.stroke.7.hovered"
      }
    }
  },
  {
    "variant": "outlined",
    "color": "danger",
    "css": {
      "color": "danger.foreground.1.enabled",
      "borderColor": "danger.stroke.1.enabled",
      "_hover": {
        "color": "danger.foreground.1.hovered",
        "backgroundColor": "neutral.background.2.hovered",
        "borderColor": "danger.stroke.1.hovered"
      },
      "_active": {
        "color": "danger.foreground.1.actived",
        "backgroundColor": "neutral.background.2.actived",
        "borderColor": "danger.stroke.1.actived"
      },
      "_expanded": {
        "color": "danger.foreground.1.hovered",
        "backgroundColor": "neutral.background.2.hovered",
        "borderColor": "danger.stroke.1.hovered"
      }
    }
  },
  {
    "variant": "ghost",
    "color": "primary",
    "css": {
      "color": "primary.foreground.2.enabled",
      "_hover": {
        "color": "primary.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered"
      },
      "_active": {
        "color": "primary.foreground.2.actived",
        "backgroundColor": "neutral.background.2.actived"
      },
      "_expanded": {
        "color": "primary.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered"
      }
    }
  },
  {
    "variant": "ghost",
    "color": "neutral",
    "css": {
      "color": "neutral.foreground.2.enabled",
      "_hover": {
        "color": "neutral.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered"
      },
      "_active": {
        "color": "neutral.foreground.2.actived",
        "backgroundColor": "neutral.background.2.actived"
      },
      "_expanded": {
        "color": "neutral.foreground.2.hovered",
        "backgroundColor": "neutral.background.2.hovered"
      }
    }
  },
  {
    "variant": "ghost",
    "color": "danger",
    "css": {
      "color": "danger.foreground.1.enabled",
      "_hover": {
        "color": "danger.foreground.1.hovered",
        "backgroundColor": "neutral.background.2.hovered"
      },
      "_active": {
        "color": "danger.foreground.1.actived",
        "backgroundColor": "neutral.background.2.actived"
      },
      "_expanded": {
        "color": "danger.foreground.1.hovered",
        "backgroundColor": "neutral.background.2.hovered"
      }
    }
  },
  {
    "color": "primary",
    "variant": "filled",
    "css": {
      "_hover": {
        "color": "primary.foreground.1.hovered",
        "backgroundColor": "primary.background.2.hovered",
        "borderColor": "primary.stroke.1.hovered"
      },
      "_active": {
        "backgroundColor": "primary.background.1.focused",
        "color": "neutral.foreground.1.enabled",
        "borderColor": "primary.stroke.1.focused"
      },
      "_expanded": {
        "color": "primary.foreground.1.enabled!"
      }
    }
  },
  {
    "color": "primary",
    "variant": "outlined",
    "css": {
      "color": "primary.foreground.1.enabled",
      "backgroundColor": "neutral.background.2.enabled",
      "borderColor": "primary.stroke.1.enabled",
      "_hover": {
        "color": "primary.foreground.1.hovered",
        "backgroundColor": "primary.background.2.hovered",
        "borderColor": "primary.stroke.1.hovered"
      },
      "_active": {
        "color": "primary.foreground.1.hovered",
        "backgroundColor": "primary.background.2.focused",
        "borderColor": "primary.stroke.1.focused"
      }
    }
  }
])

const buttonIconVariantMap = {
  "color": [
    "danger",
    "unstyled",
    "primary",
    "neutral"
  ],
  "width": [
    "block"
  ],
  "variant": [
    "unstyled",
    "outlined",
    "ghost",
    "filled"
  ],
  "size": [
    "s",
    "l",
    "m"
  ],
  "shape": [
    "rounded"
  ]
}

const buttonIconVariantKeys = Object.keys(buttonIconVariantMap)

export const buttonIcon = /* @__PURE__ */ Object.assign(memo(buttonIconFn.recipeFn), {
  __recipe__: true,
  __name__: 'buttonIcon',
  __getCompoundVariantCss__: buttonIconFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: buttonIconVariantKeys,
  variantMap: buttonIconVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, buttonIconVariantKeys)
  },
  getVariantProps: buttonIconFn.getVariantProps,
})